<div class="container">
  <div class="tree-header">
    <button mjButton (click)="clearSelection()">All Files</button>
    <button mjButton variant="primary" size="sm" (click)="createNewCategory()">Add category</button>
  </div>

  <div class="category-tree">
    @for (node of rootNodes; track node.ID) {
      <ng-container *ngTemplateOutlet="treeNode; context: { $implicit: node, level: 0 }"></ng-container>
    }
  </div>

  <ng-template #treeNode let-node let-level="level">
    <div class="tree-node" [style.padding-left.px]="level * 20">
      <div class="tree-node-row"
           [class.selected]="isSelected(node)"
           (click)="selectNode(node)"
           (contextmenu)="onContextMenu($event, node)">
        @if (hasChildren(node)) {
          <button class="tree-expand-btn" (click)="toggleExpand(node, $event)">
            <i class="fa-solid" [class.fa-chevron-right]="!isExpanded(node)" [class.fa-chevron-down]="isExpanded(node)"></i>
          </button>
        } @else {
          <span class="tree-expand-placeholder"></span>
        }
        <i class="fa-solid fa-folder tree-folder-icon"></i>
        <span class="tree-node-label">{{ node.Name }}</span>
      </div>
      @if (isExpanded(node)) {
        @for (child of getChildren(node); track child.ID) {
          <ng-container *ngTemplateOutlet="treeNode; context: { $implicit: child, level: level + 1 }"></ng-container>
        }
      }
    </div>
  </ng-template>

  <!-- Context Menu -->
  @if (contextMenuVisible) {
    <div class="context-menu"
         [style.top.px]="contextMenuY"
         [style.left.px]="contextMenuX"
         (document:click)="closeContextMenu()">
      <button class="context-menu-item" (click)="onContextMenuAction('rename')">
        <i class="fa-solid fa-pen"></i> Rename
      </button>
      <button class="context-menu-item" (click)="onContextMenuAction('delete')" disabled>
        <i class="fa-solid fa-trash-can"></i> Delete
      </button>
    </div>
  }

  <mj-dialog
    [Visible]="showNew"
    Title="New file category"
    [Width]="450"
    [MinWidth]="250"
    (Close)="cancelNewCategory()">
    <div class="dialog-form-container">
      <form #newForm="ngForm">
        <label class="mj-form-field">
          <span class="mj-form-label">Name</span>
          <input
            class="mj-input"
            name="name"
            [(ngModel)]="newCategoryName"
            required
            [disabled]="isLoading" />
        </label>
      </form>
    </div>
    <mj-dialog-actions>
      <button mjButton variant="primary" (click)="saveNewCategory()" [disabled]="isLoading">Save</button>
      <button mjButton (click)="cancelNewCategory()" [disabled]="isLoading">Cancel</button>
    </mj-dialog-actions>
  </mj-dialog>

  @if (!!renameFileCategory) {
    <mj-dialog
      [Visible]="true"
      Title="Rename file category"
      [Width]="450"
      [MinWidth]="250"
      (Close)="cancelRename()">
      <div class="dialog-form-container">
        <form #renameForm="ngForm">
          <label class="mj-form-field">
            <span class="mj-form-label">Name</span>
            <input
              class="mj-input"
              name="Name"
              [(ngModel)]="renameFileCategory.Name"
              required
              [disabled]="isLoading" />
          </label>
        </form>
      </div>
      <mj-dialog-actions>
        <button mjButton variant="primary" (click)="saveRename()" [disabled]="isLoading || !renameFileCategory.Dirty">Save</button>
        <button mjButton (click)="cancelRename()" [disabled]="isLoading">Cancel</button>
      </mj-dialog-actions>
    </mj-dialog>
  }
</div>
